// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1qAK0","content":"styles_content__15LIe","selectAll":"styles_selectAll__2OLyL"};